export default {
  placeholder: 'Schweregrade auswählen',
};
